module.exports = "/_next/static/images/kp-770cb198413d6cbb87d3067604cdf7a9.svg";